import * as React from 'react'
import { withRouter, RouteComponentProps, Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Table, Icon, Row, Col } from 'antd'
import { TimeFormat, calcPriority, PhoneFormat } from '@utils/index'
import { ComponentExt } from '@utils/reactExt'
import { inquiryStatus } from '@texts/inquiries'
import PopupAssignUser from '@components/Popup/AssignUser'
import * as styles from './index.scss'

type ListProps = RouteComponentProps<any> & {
    inquiries?: any
    filters?: {
        read?: number
        type?: string
        startDate?: string
        endDate?: string
        clientSearch?: string
    }
}

@inject((store: any) => {
    const { inquiries } = store

    return {
        inquiries
    }
})
@observer
class InquiriesList extends ComponentExt<ListProps, any> {
    handleTableChange = e => {
        this.props.inquiries.getInquiries({ pageIndex: e.current })
    }
    componentDidMount() {
        this.props.inquiries.updateFilters(this.props.filters ? this.props.filters : {})
        this.props.inquiries.getInquiries({ pageIndex: 1 })
    }
    render() {
        const { list, loading, totalCount, pageIndex, filters } = toJS(this.props.inquiries)

        const columns = [
            {
                title: 'מספר פניה',
                key: 'inquiry_id',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'תאריך הפניה',
                key: 'date',
                render: (_, record) => <span>{TimeFormat(record.createdAt)}</span>
            },
            {
                title: 'לקוח',
                key: 'client_name',
                render: (_, record) => {
                    return <span>{record.assignedCustomer.name}</span>
                }
            },
            {
                key: 'priority',
                render: (_, record) => {
                    let priorityColor = calcPriority(record.createdAt, record.dueDate, record.status)
                    return <span className={styles.priority} style={{ backgroundColor: priorityColor }}></span>
                }
            },
            {
                title: 'מצב פניה',
                key: 'inquiry_status',
                render: (_, record) => {
                    return <span>{inquiryStatus[record.status]}</span>
                }
            },
            {
                title: 'בטיפול של',
                key: 'assign_to',
                render: (_, record) => {
                    return (
                        <PopupAssignUser
                            id={record.id}
                            assignedUser={record.assignedUser.id ? record.assignedUser : {}}
                            update={() => this.props.inquiries.getInquiries({ pageIndex, filters })}
                        />
                    )
                }
            },
            {
                title: 'אימייל',
                key: 'email',
                render: (_, record) => {
                    return <a href={`mailto:${record.assignedCustomer.email}`}>{record.assignedCustomer.email}</a>
                }
            },
            {
                title: 'טלפון',
                key: 'phone',
                render: (_, record) => {
                    return <span>{PhoneFormat(record.assignedCustomer.phone)}</span>
                }
            },
            {
                title: 'שלבי הגעה',
                key: 'path',
                render: (_, record) => {
                    const path = record.path.map((point, index) => (
                        <a
                            key={`${index}_${record.id}`}
                            target="_blank"
                            href={`/docs/${point}`}
                            style={{ color: 'black' }}
                        >
                            {point} {record.path[index + 1] && <Icon type="arrow-left" style={{ margin: '0 3px' }} />}
                        </a>
                    ))
                    return path
                }
            },
            {
                title: 'פעולות',
                key: 'actions',
                render: (_, record) => {
                    return (
                        <div style={{ padding: '20px 0', color: '#e77910', minWidth: '260px' }}>
                            <a href="" style={{ textDecoration: 'underline' }}>
                                <Icon
                                    type="wechat"
                                    style={{
                                        fontSize: '20px',
                                        margin: '0 5px'
                                    }}
                                />
                                פתח צ'אט
                            </a>
                            <span style={{ margin: '0 10px' }}>|</span>
                            <Link
                                to={`/inquiries/${record.id}`}
                                style={{
                                    backgroundColor: '#e77910',
                                    padding: '6px 10px 8px 5px',
                                    color: 'white',
                                    borderRadius: '3px'
                                }}
                            >
                                עבור לפניה
                                <Icon
                                    type="left"
                                    style={{
                                        fontSize: '15px',
                                        position: 'relative',
                                        top: '-2px',
                                        margin: '0 5px 0 0'
                                    }}
                                />
                            </Link>
                        </div>
                    )
                }
            }
        ]
        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            rowClassName={record => (record.assignedUser.id ? '' : styles.unassigned)}
                            columns={columns}
                            dataSource={list}
                            pagination={{
                                total: totalCount,
                                pageSize: 10,
                                current: pageIndex
                            }}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRouter(InquiriesList)
